var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4067 0C17.6918 9.52448e-06 17.9525 0.160244 18.0803 0.414C18.2082 0.668184 18.1808 0.972542 18.0094 1.2L11.3792 10.0672V15.375C11.3784 15.8469 11.1553 16.2912 10.7765 16.575L9.26963 17.7C9.00898 17.8951 8.69161 18.0004 8.36551 18C7.53586 17.9939 6.8648 17.3259 6.85865 16.5V10.0672L0.228449 1.2C0.0572221 0.972737 0.0296797 0.668678 0.157305 0.41459C0.28493 0.160502 0.545816 0 0.831195 0H17.4067ZM7.12687 5.5875L4.1591 1.65C4.08843 1.5562 3.97776 1.50071 3.85999 1.5H3.10655C2.96386 1.5 2.83342 1.58025 2.76961 1.70729C2.7058 1.83434 2.71957 1.98637 2.80518 2.1L6.52412 6.975C6.62141 7.10413 6.79079 7.1568 6.94462 7.10576C7.09845 7.05471 7.20221 6.91141 7.20221 6.75V5.8125C7.20221 5.73136 7.17577 5.65241 7.12687 5.5875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.728a4e1b.svg";
export { ForwardRef as ReactComponent };